<template>
  <a href="#main-content" class="skip-nav">Skip to Main Content</a>
  <NavBar @open-device="isDeviceModalShown = true" />

  <slot />

  <Device v-model="isDeviceModalShown" />
</template>

<script>
import NavBar from "@/components/NavBar.vue"
import Device from "@/components/dialog/DeviceDialog.vue"

export default {
  components: { NavBar, Device },
  data() {
    return {
      isDeviceModalShown: false
    }
  }
}
</script>

<style scoped>
.skip-nav {
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.skip-nav:focus {
  position: static;
  display: block;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 4px 0;
  background: lightgray;
  color: #6b7280;
  border-radius: 0;
  z-index: 1000;
  text-align: center;
  text-decoration: none;
}


.page-content {
  padding: 24px;
  min-height: calc(100vh - 56px - 60px);
}

.footer {
  border-top: 1px solid #e5e7eb;
  padding: 16px;
  text-align: center;
  color: #6b7280;
}
.nav-bar {
  position: sticky;
  top: 0;
  z-index: 1000;

}

</style>
